import { ToolBar } from '@/app/editor/iframe/atom/utils/ToolBar';
import { Dragable } from '@/app/editor/iframe/atom/utils/Dragable';
import { Outline } from '@/app/editor/iframe/atom/utils/Outline';
import type { TypeSettings } from '@/app/editor/iframe/atom/Atom.model';
import { ContextMenu } from '@/app/editor/iframe/atom/utils/ContextMenu';
import { Settings } from '@/app/editor/sidebar/settings/Settings';
export default {
  /**
   * Init Atom when using Utilities Classes
   * @param $el DOM ($atom)
   * @param data atom Data
   */
  Init($el: JQuery, data: TypeSettings) {
    new ToolBar($el[0]);
    new Dragable($el[0]);
    new Settings($el[0]);
    new Outline($el[0], {
      atom: data.atom,
    });
    new ContextMenu($el[0], {
      atom: data.atom,
    });
  },
};
